import { SCREEN_NAME } from 'constants/index';
import {
  sendScreenEvent,
  sendUIEvent,
  sendTrackEvent,
} from 'services/analytics';

interface AnalyticsAttributes {
  [key: string]: any;
}

const ANALYTICS_SOURCE = SCREEN_NAME.SETTINGS;

// https://data-portal.internal.atlassian.com/analytics/registry/84834
const trackSettingsScreenView = () => {
  sendScreenEvent({
    screenName: ANALYTICS_SOURCE,
    isPersonalView: true,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/84863
const trackLinkAccountButtonClick = () => {
  sendUIEvent({
    source: ANALYTICS_SOURCE,
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'unifiedProfileLinkAccount',
    isPersonalView: true,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/84864
const trackAccountLinkingSuccess = (attributes?: AnalyticsAttributes) => {
  sendTrackEvent({
    source: ANALYTICS_SOURCE,
    action: 'succeeded',
    actionSubject: 'unifiedProfileAccountLinking',
    attributes: attributes,
    isPersonalView: true,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/84865
const trackAccountLinkingFailure = (
  errorCode: string,
  phase?: 'initialization' | 'completion',
  attributes?: AnalyticsAttributes,
) => {
  sendTrackEvent({
    source: ANALYTICS_SOURCE,
    action: 'failed',
    actionSubject: 'unifiedProfileAccountLinking',
    attributes: {
      errorCode,
      ...(phase && { phase }),
      ...attributes,
    },
    isPersonalView: true,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/84866
const trackUnlinkAccountButtonClick = () => {
  sendUIEvent({
    source: ANALYTICS_SOURCE,
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'unifiedProfileUnlinkAccount',
    isPersonalView: true,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/84867
const trackAccountUnlinkingSuccess = (attributes?: AnalyticsAttributes) => {
  sendTrackEvent({
    source: ANALYTICS_SOURCE,
    action: 'succeeded',
    actionSubject: 'unifiedProfileAccountUnlinking',
    attributes: attributes,
    isPersonalView: true,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/84868
const trackAccountUnlinkingFailure = (
  errorCode: string,
  attributes?: AnalyticsAttributes,
) => {
  sendTrackEvent({
    source: ANALYTICS_SOURCE,
    action: 'failed',
    actionSubject: 'unifiedProfileAccountUnlinking',
    attributes: { errorCode, ...attributes },
    isPersonalView: true,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/84870
const trackMakePrimaryAccountButtonClick = () => {
  sendUIEvent({
    source: ANALYTICS_SOURCE,
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'unifiedProfileMakePrimaryAccount',
    isPersonalView: true,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/84871
const trackMakePrimaryAccountSuccess = (attributes?: AnalyticsAttributes) => {
  sendTrackEvent({
    source: ANALYTICS_SOURCE,
    action: 'succeeded',
    actionSubject: 'unifiedProfileMakePrimaryAccount',
    attributes: attributes,
    isPersonalView: true,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/84872
const trackMakePrimaryAccountFailure = (
  errorCode: string,
  attributes?: AnalyticsAttributes,
) => {
  sendTrackEvent({
    source: ANALYTICS_SOURCE,
    action: 'failed',
    actionSubject: 'unifiedProfileMakePrimaryAccount',
    attributes: { errorCode, ...attributes },
    isPersonalView: true,
  });
};

export {
  trackSettingsScreenView,
  trackLinkAccountButtonClick,
  trackAccountLinkingSuccess,
  trackAccountLinkingFailure,
  trackUnlinkAccountButtonClick,
  trackAccountUnlinkingSuccess,
  trackAccountUnlinkingFailure,
  trackMakePrimaryAccountButtonClick,
  trackMakePrimaryAccountSuccess,
  trackMakePrimaryAccountFailure,
};
